import {observer} from "mobx-react";
import styled from "styled-components";
import {useEffect, useState} from "react";
import {useStore} from "@/store";
import {IoIosCloseCircleOutline, IoMdClose} from "react-icons/io";
import {SIZES} from "@/components/constants";
const COOKIE_PREFIX = "popup_hide_";
const MainPopupWrap = observer(() => {
    const {popupManageStore} = useStore();
    const [closedIds, setClosedIds] = useState([]); // 닫기/오늘하루 숨긴 팝업 id
    useEffect(() => {
        popupManageStore.setFetchPopupList().then();
    }, []);
    const isHiddenByCookie = (id) => {
        if (typeof document === "undefined") return false;
        const cookies = document.cookie.split(";").map(c => c.trim());
        return cookies.some(c => c.startsWith(`${COOKIE_PREFIX}${id}=`));
    };
    const handleHideToday = (id) => {
        if (typeof document === "undefined") return;
        const expire = new Date();
        expire.setHours(23, 59, 59, 999);
        document.cookie = `${COOKIE_PREFIX}${id}=1; path=/; expires=${expire.toUTCString()}`;
        setClosedIds(prev => prev.includes(id) ? prev : [...prev, id]);
    };
    const handleClose = (id) => {
        setClosedIds(prev => prev.includes(id) ? prev : [...prev, id]);
    };
    return(
        <>
            {
                popupManageStore.popupList
                && popupManageStore.popupList.length > 0
                && popupManageStore.popupList.filter(item => !isHiddenByCookie(item._id) && !closedIds.includes(item._id)).map((item, idx) =>
                    <MainPopupWrapInner
                        key={idx}
                        $width={item.data.location?.width}
                        $height={item.data.location?.height}
                        $top={item.data.location?.top}
                        $left={item.data.location?.left}
                    >
                        <div className={"close-wrap"}>
                            <div
                                className={"today-not-view"}
                                onClick={() => handleHideToday(item._id)}
                            >
                                오늘 하루 보지 않기
                            </div>
                            <div
                                className={"close-inner"}
                                onClick={() => handleClose(item._id)}
                            >
                                <IoMdClose size={20}/>
                            </div>
                        </div>
                        <div className={"popup-img"}
                             onClick={() => {
                                 if (item.data.url) {
                                     let url = (item.data.url || "").trim();
                                     if (!url) return;
                                     if (!/^https?:\/\//i.test(url)) {
                                         url = `https://${url}`;
                                     }
                                     window.open(url, "_blank", "noopener,noreferrer");
                                 }
                             }}
                        >
                            {
                                typeof item.data.image === "string" ?
                                    <div className={"img-wrap"}>
                                        <img src={JSON.parse(item.data.image).path} alt={`${item.title}`}/>
                                    </div>
                                    :
                                    <div className={"img-wrap"}>
                                        <img src={item.data.image.path} alt={`${item.title}`}/>
                                    </div>
                            }
                        </div>
                    </MainPopupWrapInner>
                )
            }
        </>

    )
});
const MainPopupWrapInner = styled.div`
    position: fixed;
    z-index: 45;
    background-color: #fff;
    width: ${(props) => props.$width ? `${parseInt(props.$width) + 22}px` : "342px"};
    top: ${(props) => props.$top ? `${props.$top}px` : "20px"};
    left: ${(props) => props.$left ? `${props.$left}px` : "20px"};
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.08), 0 4px 16px -4px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .popup-img {
        padding: 0 10px 10px;
        cursor: pointer;

        .img-wrap {
            height: ${(props) => props.$height ? `${props.$height}px` : "400px"};

            img{
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
    }
    .close-wrap{
        display: flex;
        justify-content: space-between;
        flex-shrink: 0;
        margin: 10px;
        height: 24px;
        align-items: center;
        .today-not-view{
            cursor: pointer;
            font-size: 14px;
            font-weight: 600;
            color: #181D27;
        }
        .close-inner{
            cursor: pointer;
            font-size: 14px;
            font-weight: 600;
            color: #181D27;
            display: flex;
            align-items: center;
            gap: 3px;
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        max-width: 342px;
        width: calc(100% - 36px);
        z-index: 51;
        .popup-img{
            .img-wrap{
                width: 100%;
                height: 400px;
            }
        }
    }
`
export default MainPopupWrap;